import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { DialogService } from '../../dialog/dialog.service';
import { ListFilters, Setting } from '../../shared/interfaces';
import { permissions } from '../../shared/permissions';
import { UserService } from '../../user/user.service';
import { SettingService } from '../setting.service';
import { getOrderIconClasses } from '../../shared/sort-order-icon.helper';

@Component({
  selector: 'app-setting-list',
  templateUrl: './setting-list.component.html',
  styleUrls: ['./setting-list.component.scss'],
})
export class SettingListComponent implements OnInit {
  rows: Setting[];

  page = 1;
  pageSize = 10;
  count = 0;
  searchString = '';
  orderBy = 'setting.key';
  asc = true;
  canEdit = false;

  loadDebounced = new Subject();

  constructor(
    public settingService: SettingService,
    public userService: UserService,
    private dialog: DialogService,
    private router: Router,
  ) {}

  async ngOnInit() {
    // Debounce data loading
    this.loadDebounced
      .pipe(
        debounceTime(500),
        switchMap(() => this.loadDataLive()),
      )
      .subscribe();

    this.loadDataLive();
    this.canEdit = await this.userService.hasPermissions([permissions.SETTING.WRITE]);
  }

  loadData() {
    this.loadDebounced.next();
  }

  async loadDataLive() {
    [this.rows, this.count] = await this.settingService.list(this.getParams()).toPromise();
  }

  getParams(): ListFilters {
    return {
      page: this.page,
      pageSize: this.pageSize,
      search: this.searchString,
      orderBy: this.orderBy,
      asc: this.asc,
    };
  }

  onPageChanged(page: number) {
    this.page = page;
    this.loadDataLive();
  }

  setOrder(field: string) {
    this.asc = this.orderBy === field ? !this.asc : true;
    this.orderBy = field;
    this.page = 1;
    this.loadDataLive();
  }

  getOrderIcon(field: string) {
    return getOrderIconClasses(field, this.orderBy, this.asc);
  }

  async remove(setting: Setting) {
    this.dialog.confirm().show({
      message: `Do you really want to permanently delete '${setting.key}'?`,
      confirmed: async () => {
        await this.settingService.remove(setting.id);
        this.loadDataLive();
      },
    });
  }

  open(ev, id: number) {
    if (ev.target.tagName === 'TD') {
      this.router.navigateByUrl(`/setting/form/${id}`);
    }
  }
}
